import { render, staticRenderFns } from "./DialogRenovation.vue?vue&type=template&id=715a6044&scoped=true"
import script from "./DialogRenovation.vue?vue&type=script&lang=ts"
export * from "./DialogRenovation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715a6044",
  null
  
)

export default component.exports